import { useState } from "react"
import { Container,Row,Col } from "react-bootstrap";
import contactImg from '../assets/img/contact-img.svg';
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Contact = ()=>{
    const formInitialDetails={
        firstName:'A. V ',
        lastName: 'Sai Ram Reddy',
        email: 'sairamrdya@gmail.com',
        phone: '8247787962',
        message: ''
    }

    const [formDetails,setformDetails]=useState(formInitialDetails);
    const [buttonText,setButtonText]=useState('Send');
    const [status,setStatus]=useState({});

    const onFormUpdate=(category,value)=>{
        setformDetails({
            ...formDetails,
            [category]:value
        })
    }

    const handleSubmit=async (e)=>{
        e.preventDefault();
        setButtonText('Sending...');
        let response=await fetch("http://localhost:5000/contact",{
            method: "POST",
            headers:{
                "Content-type":"Application/json;charset=utf-8",
            },
            body: JSON.stringify(formDetails),
        });
        setButtonText("Send");
        let result=response.json();
        setformDetails(formInitialDetails);
        if (result.code===200){
            setStatus({success: true,message: "Message sent succesfully"});
        }
        else{
            setStatus({success: false, message: "Message not sent. Please try again"});
        }
    }


    return(
        <section className="contact" id="contact">
            <Container>
                <Row className="align-items-center">
                    <Col md={6}>
                        <img src={contactImg} alt="contact us"/>
                    </Col>
                    <Col md={6}>
                    <TrackVisibility>
                        {({isVisible})=>(
                        <div className={isVisible?"animate__animated animate__bounceInDown":""}>
                        <h2>Get In Touch</h2>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input type="text" values={formDetails.firstName} placeholder="first Name" onChange={(e)=>onFormUpdate('firstName',e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="text" values={formDetails.lastName} placeholder="Last Name" onChange={(e)=>onFormUpdate('lastName',e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="email" values={formDetails.email} placeholder="Email Address" onChange={(e)=>onFormUpdate('email',e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input type="tel" values={formDetails.phone} placeholder="Phone no" onChange={(e)=>onFormUpdate('phone',e.target.value)} />
                                </Col>
                                <Col>
                                    <textarea row="6" value={formDetails.message} placeholder="Message"  onChange={(e)=>onFormUpdate('message',e.target.value)}></textarea>
                                    <button type="submit"><span>{buttonText}</span></button>    
                                </Col>
                                {
                                    status.message &&
                                    <Col>
                                        <p className={status.success===false?"danger":"success"}></p>
                                    </Col>
                                }
                            </Row>
                        </form>
                        </div>)}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}